import { render } from "./Json.vue?vue&type=template&id=04bdeb44&lang=pug"
import script from "./Json.vue?vue&type=script&lang=js"
export * from "./Json.vue?vue&type=script&lang=js"

import "./Json.vue?vue&type=style&index=0&id=04bdeb44&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__